<template>
  <div class="fullwidth">
    <o-table
        class="mb-4"
        :class="{ 'o-table-has-pagination': configList.length }"
        :data="configList"
        checkable
        :checked-rows.sync="checkedRows"
        hoverable
    >
      <o-table-column
          v-slot="{ row, index }"
          field="name"
          label="env name"
      >
        {{ row.name }}
      </o-table-column>
      <o-table-column
          v-slot="{ row, index }"
          field="url"
          label="url"
      >
        {{ row.url }}
      </o-table-column>
    </o-table>
    <input
      ref="addressUploader"
      accept=".csv"
      :style="{display: 'none'}"
      type="file"
      @input="onFileChange"
    >
    <div class="flex align-center justify-center mb-4">
      <GlButton :disabled="!checkedRows.length" title="Upload Address Labels" class="mr-3" dark @click="openFileInput('address')" />
      <GlButton :disabled="!checkedRows.length" title="Upload Cluster Labels" dark @click="openFileInput('cluster')" />
    </div>

    <div v-if="lastUploadedList.length">
      <div class="page-title">
        Bulk Upload History
      </div>
      <o-table
        class="mb-4"
        :class="{ 'o-table-has-pagination': lastUploadedList.length }"
        :data="lastUploadedList"
        paginated
        default-sort="uploadData.date"
        default-sort-direction="desc"
        per-page="10"
        :total="lastUploadedList.length"
        hoverable
      >
        <o-table-column
          v-slot="{ row, index }"
          label="name"
        >
          {{ row.name }}
        </o-table-column>
        <o-table-column
          v-slot="{ row, index }"
          label="url"
        >
          {{ row.url }}
        </o-table-column>
        <o-table-column
          v-slot="{ row, index }"
          label="upload date"
          field="uploadData.date"
          sortable
        >
          {{ row.uploadData && row.uploadData.date || '--' }}
        </o-table-column>
        <o-table-column
          v-slot="{ row, index }"
          label="upload status"
        >
          <div v-if="row.loading">
            pending
          </div>
          <div
            v-else
            :class="[{'agree-text': row.statusUpload === 'success'}, {'warning-text': row.statusUpload === 'failed'}]"
          >
            {{ row.statusUpload }}
          </div>
        </o-table-column>
        <o-table-column
          v-slot="{ row, index }"
          label="upload report"
        >
          <GlButton v-if="row.uploadData" title="Check result" dark @click="checkUploadResult(row)" />
          <div v-else>--</div>
        </o-table-column>
        <o-table-column
          v-slot="{ row, index }"
          label="upload file"
        >
          <gl-menu-item
            v-if="row.uploadData && row.uploadData.uploadedFile"
            icon="save"
            :label="row.uploadData.uploadedFileName"
            :icon-height="24"
            :icon-width="24"
            @click="exportFile(row.uploadData.uploadedFile, row.uploadData.uploadedFileName)"
          />
          <div v-else>--</div>
        </o-table-column>
      </o-table>
    </div>
    <AddressTagsUploadedModal
      v-if="addressUploaded"
      v-model="addressUploaded"
      :data="uploadedData.uploadData"
      @close="addressUploaded = false"
    />
  </div>
</template>

<script>
//Vuex
import { mapState, mapMutations } from "vuex";
// Components
import GlButton from "@/components/gl-button.vue";
import GlMenuItem from "@/components/gl-menu-item.vue";
import GlLoader from "@/components/gl-loader.vue";
import AddressTagsUploadedModal from "@/pages/multi-labeling/components/AddressTagsUploadedModal.vue";
// Utils
import apiService from '@/utils/api-client';
import moment from "moment";
import { csvExport } from '@/utils/export-data'

export default {
  components: {
    GlButton,
    GlLoader,
    GlMenuItem,
    AddressTagsUploadedModal,
  },
  data() {
    return {
      checkedRows: [],
      lastUploadedList: [],
      resultData: {},
      uploadedData: {},
      addressUploaded: false,
      uploadFileType: '',
    }
  },
  computed: {
    ...mapState('config', ['configList']),
  },
  mounted() {
    if (localStorage.getItem('resulData')) {
      this.lastUploadedList = JSON.parse(localStorage.getItem('resulData'))
    }
  },
  methods: {
    ...mapMutations('config', ['SET_CONFIG']),
    moment,
    csvExport,
    checkUploadResult(data) {
      this.uploadedData = data
      this.addressUploaded = true
    },
    openFileInput(type) {
      this.uploadFileType = type
      this.$refs.addressUploader.click()
    },
    exportFile(file, name) {
      const a = document.createElement("a"),
          url = window.URL.createObjectURL(file);
      a.href = url;
      a.download = name || 'csv-labeling';
      document.body.appendChild(a);
      a.click();
      setTimeout(function() {
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }, 0);
    },
    onFileChange(e) {
      this.file = e.target.files[0]
      e.target.value = ''

      let formData = new FormData();

      formData.append('file', this.file);

      this.checkedRows.forEach((item) => {
        apiService.post( `${item.url}`,
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
                'x-api-key': item.apiKey
              },
            }
        ).then(({ data, success }) => {
          if (success) {
            this.resultData = {
              ...item,
              statusUpload: 'success',
              uploadData: {
                ...data,
                uploadedFile: this.file,
                uploadedFileName: this.file.name,
                type: this.uploadFileType,
                date: moment().format('DD.MM.YYYY HH:mm'),
                serverName: item.name,
                log: data.log.map(item => ({
                  address: item.address,
                  owner: item.owner,
                  type: item.type,
                  tags: `"${item.tags}"`,
                  description: item.description,
                  status: item.status,
                  statusDetails: item.statusDetails,
                }))
              }
            }
          } else {
            this.resultData = {
              ...item,
              statusUpload: 'failed',
              uploadData: {
                ...data,
                uploadedFile: this.file,
                type: this.uploadFileType,
                date: moment().format('DD.MM.YYYY HH:mm'),
                serverName: item.name,
                log: data.log.map(item => ({
                  address: item.address,
                  owner: item.owner,
                  type: item.type,
                  tags: `"${item.tags}"`,
                  description: item.description,
                  status: item.status,
                  statusDetails: item.statusDetails,
                }))
              }
            }
          }

          this.lastUploadedList.unshift(this.resultData)
        })
          .catch(() => {
            this.resultData = {
              ...item,
              statusUpload: 'failed',
              uploadData: null
            }

            this.lastUploadedList.unshift(this.resultData)
            }).finally(() => {
          localStorage.setItem('resulData', JSON.stringify(this.lastUploadedList))
          this.checkedRows = []
        })
      })
    },
  },
}
</script>
